import { render, staticRenderFns } from "./AddInterveneRecord.vue?vue&type=template&id=a88dd8b8&scoped=true"
import script from "./AddInterveneRecord.vue?vue&type=script&lang=js"
export * from "./AddInterveneRecord.vue?vue&type=script&lang=js"
import style0 from "./AddInterveneRecord.vue?vue&type=style&index=0&id=a88dd8b8&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88dd8b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a88dd8b8')) {
      api.createRecord('a88dd8b8', component.options)
    } else {
      api.reload('a88dd8b8', component.options)
    }
    module.hot.accept("./AddInterveneRecord.vue?vue&type=template&id=a88dd8b8&scoped=true", function () {
      api.rerender('a88dd8b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CommonPage/MainCareStuOverview/components/AddInterveneRecord.vue"
export default component.exports